<script setup lang="ts">
import { ProblemProps } from "./Problem.props"

defineProps<ProblemProps>()
</script>

<template>
  <div
    class="
      search-problem
      flex
      h-full
      flex-col
      items-center
      justify-center
      bg-grey-main
      px-4
      py-5
      md:p-8
    "
  >
    <div class="relative mb-4 pl-4 md:mb-12">
      <div
        class="
          absolute
          left-0
          top-0
          h-14
          w-14
          rounded-full
          bg-white
          md:h-[76px]
          md:w-[76px]
        "
      ></div>
      <UtilsIcon
        name="Problem.svg"
        color="tiffany-main"
        class="relative h-20 w-auto text-tiffany-main md:h-[120px]"
      />
    </div>
    <UtilsMarkdown class="beaver md:dolphin text-center" :content="text" />
  </div>
</template>
